<template>
  <div class="ac-card">
    <div class="ac-header">
      <div class="ac-title">💰 账户</div>
    </div>
    <div class="ac-items">
      <div class="ac-item">
        <span class="ac-label">初始资金</span>
        <span class="ac-value">{{ formatMoney(account.initialCapital) }}</span>
      </div>
      <div class="ac-item">
        <span class="ac-label">当前权益</span>
        <span class="ac-value ac-value-primary">{{ formatMoney(account.currentCapital) }}</span>
      </div>
      <div class="ac-item">
        <span class="ac-label">总盈亏</span>
        <span class="ac-value" :class="account.totalPnl >= 0 ? 'profit' : 'loss'">
          {{ formatPnl(account.totalPnl) }}
        </span>
      </div>
      <div class="ac-item">
        <span class="ac-label">累计盈亏</span>
        <span class="ac-value" :class="(account.cumulativePnl || 0) >= 0 ? 'profit' : 'loss'">
          {{ formatPnl(account.cumulativePnl || 0) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountCard',
  props: {
    account: {
      type: Object,
      default: () => ({
        initialCapital: 1000000,
        currentCapital: 1000000,
        totalPnl: 0
      })
    }
  },
  methods: {
    formatMoney(value) {
      return `¥${(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
    },
    formatPnl(value) {
      const num = value || 0
      return (num >= 0 ? '+' : '') + `¥${num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
    }
  }
}
</script>

<style scoped>
.ac-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ac-header {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  border-bottom: 1px solid #2a2e39;
}

.ac-title {
  font-size: 11px;
  font-weight: 600;
  color: #d1d4dc;
}

.ac-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ac-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  padding: 2px 0;
}

.ac-label {
  color: #787b86;
}

.ac-value {
  font-weight: 500;
  color: #d1d4dc;
  font-size: 11px;
}

.ac-value-primary {
  color: #2962ff;
  font-size: 12px;
  font-weight: 600;
}

.ac-value.profit {
  color: #f23645;
}

.ac-value.loss {
  color: #089981;
}
</style>
